module.exports = __webpack_public_path__ + "static/media/01-dr.4528ad92.png";